import * as angular from 'angular';
import * as _ from 'lodash';
import './styling.scss';
import * as template from './template.html';
import { IAugmentedJQuery } from 'angular';
import { AnalyticsService } from 'common/source/services/analytics';
import { CurrentUserService } from 'services/currentUser';
import { openUrlInNewTab } from 'common/source/utilities/windowHelper';

const module = angular.module('renewal-card', []);

interface RenewalCardController extends angular.IStrictController {
    downloadRenewalDoc: () => void;
    renewalDocUrl?: string;
}

module.component('renewalCard', {
    template: template,
    controller: function(
        this: RenewalCardController,
        $stateParams: StateParams,
        $element: IAugmentedJQuery,
        currentUserService: CurrentUserService,
        analyticsService: AnalyticsService
    ) {
        this.$onInit = () => {
            const policyIndex = $stateParams.policyIndex;

            if (policyIndex) {
                currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                    const renewalOffer = policyInfo.aggregate_documents.next_renewal_offer;
                    if (!!renewalOffer) {
                        this.renewalDocUrl = renewalOffer.url;
                        analyticsService.track('Renewal Offer Viewed', {
                            policy_number: policyInfo.policy_number
                        });
                    } else {
                        $element.addClass('ng-hide');
                    }
                });
            } else {
                $element.addClass('ng-hide');
            }
        };

        this.downloadRenewalDoc = () => {
            if (this.renewalDocUrl) {
                openUrlInNewTab(this.renewalDocUrl);
            }
        };
    }
});

export { module };
